import {
    DraftValidation,
    ValidationFormula,
} from "@/entities/DataAssociation/Draft.model";
import ValidationCheck from "./ValidationCheck";
import { money } from "@/utils/misc/format";

export function BalanceSheetBalanceCheck({
    defaultStatus,
    validations,
}: {
    defaultStatus?: "loading" | "neutral";
    validations: DraftValidation;
}) {
    return (
        <li>
            <ValidationCheck
                title="Balance Sheet Balance"
                description="Assets, Liabilities, and Equity must balance."
                status={
                    defaultStatus ||
                    (validations.formulas.messages.find(
                        (message) =>
                            message.formula ===
                            ValidationFormula.BALANCE_SHEET_BALANCE,
                    )
                        ? "warning"
                        : validations.formulas.status === "loading"
                          ? "loading"
                          : "pass")
                }
                detail={validations.formulas.messages
                    .filter(
                        (message) =>
                            message.formula ===
                            ValidationFormula.BALANCE_SHEET_BALANCE,
                    )
                    .map(
                        (error) =>
                            error.period + ": " + money(error.difference),
                    )
                    .join("\n")}
            />
        </li>
    );
}
